import React, { useEffect, useState } from "react";
import MenuContainer from "../MenuContainer/MenuContainer";
import DataTable from "../DataTable/DataTable";
import chequeDemo from "../../assets/images/chequeDemo.png";
import c1 from "../../assets/dummy_npci_images/Match/c_5.jpg";
import c2 from "../../assets/dummy_npci_images/Match/c_4.jpg";
import c3 from "../../assets/dummy_npci_images/Match/c_45.jpg";
import c4 from "../../assets/dummy_npci_images/Match/c_26.jpg";
import s1 from "../../assets/dummy_npci_images/Matching_signature/c_5.jpg";
import s2 from "../../assets/dummy_npci_images/Matching_signature/c4.jpg";
import s3 from "../../assets/dummy_npci_images/Matching_signature/c450.png";
import s4 from "../../assets/dummy_npci_images/Matching_signature/c26.jpg";
import Loader from "../LoaderComponent/Loader";

function Cheque_comparison() {
  const [uniqueId, setuniqueId] = useState("1087104000005581");
  const [isLoading, setisLoading] = useState(false);
  const TableColumn = [
    {
      title: "Field",
      dataIndex: "field",
      headerCellStyle: {
        backgroundColor: "var(--mastercolor2)",
        color: "#fff",
        width:'180px',
      },
      bodyCellStyle: {
        backgroundColor: "#f0f0f0",
        color: "#000",
        fontSize: "15px",
        fontWeight:"400",
      }
    },
    {
      title: "NPCI Data",
      dataIndex: "user_input",
      headerCellStyle: {
        backgroundColor: "var(--mastercolor2)",
        color: "#fff",
        width:'180px',
        border:"none"
      },
    },
    {
      title: "Extracted",
      dataIndex: "extracted",
      headerCellStyle: {
        backgroundColor: "var(--mastercolor2)",
        color: "#fff",
        width:'260px',
        border:"none"
      },
    },
    {
      title: "Matching Details",
      dataIndex: "matchingDetails",
      headerCellStyle: {
        backgroundColor: "var(--mastercolor2)",
        color: "#fff",
        border:"none"
      },
    },
  ];
  const [tableData, setTableData] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      const data = await getTableData();
      setTableData(data);
    };

    fetchData();
  }, []);

  const getTableData = async () => {
    const tableData = [
      {
        uniqueID: "1087104000005581",
        cheque: c1,
        sign: s1,
        Cheque_validity: false,
        sign_validity:false,
        data: [
          {
            field: "Date",
            user_input: "11/08/2017",
            extracted: "17/08/2017",
            matchingDetails: "Not Match",
          },
          
          {
            field: "Name",
            user_input: "Priya Mathews",
            extracted: "PRIYA MATHEW",
            matchingDetails: "96%",
          },
          {
            field: "Amount in words",
            user_input: "Nine thousand one hundred and three",
            extracted: "NINE CRORE THIRTY SIX LAKH FORTY NINE THOUSAND ONE HUNDRED THREE",
            matchingDetails: "Not Match",
          },
          {
            field: "Amount in figures",
            user_input: "93649103",
            extracted: "93649103",
            matchingDetails: "Match",
          },
          {
            field: "Account Number",
            user_input: "1087104008885586",
            extracted: "1087104000005586",
            matchingDetails: "Not Match",
          },
          {
            field: "IFSC",
            user_input: "IBKL0001087",
            extracted: "IBKL0001087",
            matchingDetails: "Match",
          },
          {
            field: "MICR",
            user_input: "008830 682259007 108700 31",
            extracted: "008830 682259007 108700 31",
            matchingDetails: "Match",
          },
          {
            field: "Signature",
            user_input: "",
            extracted: "",
            matchingDetails: "Match",
          },
          
        ],
      },
      {
        uniqueID: "410605000054",
        cheque: c2,
        sign: s2,
        Cheque_validity: false,
        sign_validity:false,
        data: [
          {
            field: "Date",
            user_input: "18/04/2021",
            extracted: "18/04/2021",
            matchingDetails: "Match",
          },
         
          {
            field: "Name",
            user_input: "Anoop Kumar",
            extracted: "TWO CRORES",
            matchingDetails: "32%",
          },
          {
            field: "Amount in words",
            user_input: "Two lakhs",
            extracted: "TWO CRORE THIRTY FOUR LAKH EIGHTY ONE THOUSAND SEVEN HUNDRED FIFTY FOUR",
            matchingDetails: "Not Match",
          },
          {
            field: "Amount in figures",
            user_input: "200000",
            extracted: "23481754",
            matchingDetails: "Not Match",
          },
          {
            field: "Account Number",
            user_input: "410605000054",
            extracted: "410605000054",
            matchingDetails: "Match",
          },
          {
            field: "IFSC",
            user_input: "ICIC0004106 ",
            extracted: "ICIC0004106",
            matchingDetails: "Match",
          },
          {
            field: "MICR",
            user_input: "000503 682229031 000054- 29",
            extracted: "000010 682229031 000054 29",
            matchingDetails: "Not Match",
          },
          {
            field: "Signature",
            user_input: "",
            extracted: "",
            matchingDetails: "Match",
          },
        ],
      },
      {
        uniqueID: "10133892799",
        cheque: c3,
        sign: s3,
        Cheque_validity: false,
        sign_validity:false,
        data: [
          {
            field: "Date",
            user_input: "26/08/2033",
            extracted: "26/03/2083",
            matchingDetails: "Not Match",
          },
         
          {
            field: "Name",
            user_input: "Sherin Jose",
            extracted: "SHERILJOSE",
            matchingDetails: "90%",
          },
          {
            field: "Amount in words",
            user_input: "Twenty Thousand",
            extracted: "TWENTY THOUSAND",
            matchingDetails: "Match",
          },
          {
            field: "Amount in figures",
            user_input: "2000",
            extracted: "20000",
            matchingDetails: "Not Match",
          },
          {
            field: "Account Number",
            user_input: "1013381299",
            extracted: "10133892799",
            matchingDetails: "Not Match",
          },
          {
            field: "IFSC",
            user_input: "IDFB0080510",
            extracted: "IDFB0080511",
            matchingDetails: "Not Match",
          },
          {
            field: "MICR",
            user_input: "000002 682751002 001010 29",
            extracted: "000002 682751002 001010 29",
            matchingDetails: "Match",
          },
          {
            field: "Signature",
            user_input: "",
            extracted: "",
            matchingDetails: "Not Match",
          },
        ],
      },
      {
        uniqueID: "1087104000005586",
        cheque: c4,
        sign: s4,
        Cheque_validity: true,
        sign_validity:true,
        data:[
          {
            field: "Date",
            user_input: "27/04/2023",
            extracted: "27/04/2023",
            matchingDetails: "Match",
          },
          
          {
            field: "Name",
            user_input: "Aswin Kumar P",
            extracted: "ASWIN KUMAR P",
            matchingDetails: "100%",
          },
          {
            field: "Amount in words",
            user_input: "Six crore fifty four lakh thirty four thousand eight hundred fifty",
            extracted: "SIX CRORE FIFTY FOUR LAKH THIRTY FOUR THOUSAND EIGHT HUNDRED FIFTY",
            matchingDetails: "Match",
          },
          {
            field: "Amount in figures",
            user_input: "65434850",
            extracted: "65434850",
            matchingDetails: "Match",
          },
          {
            field: "Account Number",
            user_input: "1087104000005586",
            extracted: "1087104000005586",
            matchingDetails: "Match",
          },
          {
            field: "IFSC",
            user_input: "IBKL0001087",
            extracted: "IBKL0001087",
            matchingDetails: "Match",
          },
          {
            field: "MICR",
            user_input: "008833 682259007 108700 31",
            extracted: "008833 682259007 108700 31",
            matchingDetails: "Match",
          },
          {
            field: "Signature",
            user_input: "",
            extracted: "",
            matchingDetails: "Match",
          }
          
        ],
      },
    ];
    return tableData;
  };
  const handleSelect = (e) => {
  
    const { value } = e.target;
    console.log(tableData?.filter((itm) => itm.uniqueID === uniqueId));
    try {
      setisLoading(true)
      setTimeout(() => {
        
        setuniqueId(value);
        setisLoading(false)
      }, 1000);
    } catch (error) {}
  };

  return (
    <div>
       {isLoading && <Loader />}

      <MenuContainer enableSideBar={false} enableProfile={false}>
        <div className="p-3">
        <h2 class="font_22 text_master2 fw-bold mb-0  text-center">NPCI Cheque Comparison</h2>
            <div className="d-inline-block">
              <div className="d-flex flex-column ">
                <span className="font_12 fw_500 ws_nowrp">
                 Choose Account Number <span className="text-danger">*</span>
                </span>
                <select
                  className="form-select rounded font_12"
                  onChange={handleSelect}
                >
                  {["1087104000005586","410605000054", "10133892799", "1087104000005586"].map((itm) => (
                    <option value={itm}>{itm}</option>
                  ))}
                </select>
              </div>
            </div>
                
                <div className="row">
                  <div className="bd_dotted_0 bd_dotted_md bd_master2 border-bottom-0 border-start-0 border-top-0 col-12 col-md-6">
                    <div className="bd_dotted_0 bd_master2 border-bottom-0 border-start-0 border-top-0 ">
                      <div className=" align-items-center  rounded  gap-2 ">
                        <h2 className="font_16 fw-bold text-center mt-2 mb-2">
                          Cheque Image
                        </h2>
                        <div className="bg_lightdark br_15">
                          
                        <div className="br_15 d-flex justify-content-center p-1 w-100 ">
                          <img
                          src={
                            tableData?.filter((itm) => itm.uniqueID === uniqueId)[0]
                              ?.cheque
                          }
                            className="  w-100 object_fit_contain h-100 p-3 cursor-pointer "
                          />
                        </div>
                        <div className="d-none gap-2 justify-content-center pb-2">
                          <div className="">
                          <span>Cheque Validity</span>
                            </div>
                            <span>:</span>
                          <div className={`${ tableData?.filter((itm) => itm.uniqueID === uniqueId)[0]
                              ?.Cheque_validity?"badge_success_soft":"badge_danger_soft"} br_15 px-4 `}>
                            <span>{ tableData?.filter((itm) => itm.uniqueID === uniqueId)[0]
                              ?.Cheque_validity?"Valid":"Not Valid"}</span>
                          </div>
                        </div>
                      </div>
                      </div>

                      
                    </div>
                    <div className="bd_dotted_0  bd_master2 border-bottom-0 border-start-0 border-top-0 ">
                      <div className=" align-items-center  rounded  gap-2 ">
                        <h2 className="font_16 fw-bold text-center mt-2 mb-2">
                          Signature Image
                        </h2>
                        <div className="bg_lightdark br_15">
                          
                        <div className=" p-1 br_15" >
                          <img
                            src={
                              tableData?.filter((itm) => itm.uniqueID === uniqueId)[0]?.sign
                            }
                            className=" object_fit_contain w-100  p-3 cursor-pointer " style={{height:100}}
                          />
                        </div>
                        <div className="d-none gap-2 justify-content-center pb-2">
                          <div className="">
                          <span>Cheque Validity</span>
                            </div>
                            <span>:</span>
                            <div className={`${ tableData?.filter((itm) => itm.uniqueID === uniqueId)[0]
                              ?.sign_validity?"badge_success_soft":"badge_danger_soft"} br_15 px-4 `}>
                            <span>{ tableData?.filter((itm) => itm.uniqueID === uniqueId)[0]
                              ?.sign_validity?"Valid":"Not Valid"}</span>
                          </div>
                        </div>
        </div>
                      </div>

                      
                    </div>
                  </div>
                  <div className="col-6">
                    <div className="overflow-auto  scrollbar1">
                      <DataTable
                        columnData={TableColumn}
                        rowData={
                          tableData.filter((itm) => itm.uniqueID === uniqueId)[0]?.data
                        }
                      />
                    </div>
                </div>
          </div>
        </div>
      </MenuContainer>
    </div>
  );
}

export default Cheque_comparison;
